
	import { computed, defineComponent, ref } from 'vue';
	import { useRoute } from 'vue-router';

	// Components
	import BespokeEfficacyNirma from '../bespoke/efficacy-of-nirmatrelvir.vue';
	import BespokeSarsInfection from '../bespoke/sars-cov-infection-routes.vue';
	import BespokeSarsVariants from '../bespoke/sars-cov-variants.vue';
	import BespokePulmonaryManifestations from '../bespoke/pulmonary-manifestations.vue';
	import BespokeExtraPulmonaryManifestations from '../bespoke/extrapulmonary-manifestations.vue';
	import BespokeLongTermOutcomes from '../bespoke/long-term-outcomes.vue';
	import BespokeInflammatoryResponse from '../bespoke/inflammatory-response.vue';
	import BespokeGlobalCovidCases from '../bespoke/global-covid-cases.vue';
	import BespokeLongCovidDefinitions from '../bespoke/long-covid-definitions.vue';
	import OutcomesOverviewSplash from '../bespoke/outcomes-overview-splash.vue';
	import ClinicalPresentationSplash from '../bespoke/clinical-presentation-splash.vue';
	import VirologySplash from '../bespoke/virology-splash.vue';
	import DiagnosisSplash from '../bespoke/diagnosis-splash.vue';

	function bespokeComposition () {
		/**
		 * Bespoke
		 */
		const route = useRoute();

		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

		const componentMap = ref<any>({
			'efficacy-of-nirmatrelvir-2': BespokeEfficacyNirma,
			'sars-cov-2-infection-routes': BespokeSarsInfection,
			'sars-cov-2-variants': BespokeSarsVariants,
			'pulmonary-manifestations': BespokePulmonaryManifestations,
			'extrapulmonary-manifestations': BespokeExtraPulmonaryManifestations,
			'long-term-outcomes': BespokeLongTermOutcomes,
			'respiratory-and-neurological-sequelae': BespokeLongTermOutcomes,
			'inflammatory-response': BespokeInflammatoryResponse,
			'global-covid-19-cases': BespokeGlobalCovidCases,
			'long-covid-definitions': BespokeLongCovidDefinitions,
			'outcomes-overview-splash': OutcomesOverviewSplash,
			'clinical-presentation-splash': ClinicalPresentationSplash,
			'virology-splash': VirologySplash,
			'diagnosis-splash': DiagnosisSplash
		})

		function activeComponent () {
			return (componentMap.value[endpointId.value] || null);
		}

		return { activeComponent }
	}

	export default defineComponent ({
		props: {
			datum: {
				type: Object,
				required: true,
			}
		},
		setup() {
			return { ...bespokeComposition() }
		}
	})
